<template>
  <Container>
    <v-flex justify-start>
      <v-card>
        <v-toolbar dark>
          <v-toolbar-title>Subtitle Video Localization Manager</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-flex>
            <v-autocomplete
              label="Select Language"
              v-model="selectedLanguage"
              :items="languageList"
              chips
              hide-details
              hide-no-data
              hide-selected
            ></v-autocomplete>
          </v-flex>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
          <div v-if="userLevel === 99">
            <v-btn color="success" @click="onClickAddLanguage()">
              Create
            </v-btn>
          </div>
        </v-toolbar>
        <v-card>
          <v-card-title>
            <v-text-field
              v-if="selectedLanguage === 'Arabic'"
              dir="rtl"
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
            ></v-text-field>
            <v-text-field
              v-if="selectedLanguage !== 'Arabic'"
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
            ></v-text-field>
          </v-card-title>
          <v-data-table
            :headers="header"
            :items="languageStore"
            :search="search"
            :pagination.sync="pagination"
            class="elevation-1"
          >
            <template v-slot:items="props">
              <td class="text-xs-center">{{ props.item.created_at }}</td>
              <td class="text-xs-center">{{ props.item.updated_at }}</td>
              <td class="text-xs-center">{{ props.item.video_uri }}</td>
              <td class="text-xs-center">
                {{ props.item.English }}
              </td>
              <td class="text-xs-center">
                {{ props.item[selectedLanguage] }}
              </td>
              <td class="justify-center layout px-0">
                <v-icon
                  small
                  class="mr-2"
                  @click="onClickEditLanguage(props.item)"
                  >edit</v-icon
                >
                <v-icon
                  v-if="userLevel === 99"
                  small
                  @click="
                    onClickDeleteLanguage(props.item._id, props.item.English)
                  "
                  >delete</v-icon
                >
              </td>
            </template>
          </v-data-table>
        </v-card>
      </v-card>
    </v-flex>
    <!-- Edit Modal -->
    <Modal
      v-if="isEdit"
      :isOpen="isEdit"
      :save="onSaveEdit"
      :close="onCloseEdit"
      title="Edit"
    >
      <v-card>
        <v-container>
          <v-layout grid-list-xs column text-xs-center>
            <v-flex>
              <v-text-field
                readonly
                label="Video URI"
                v-model.trim="language.video_uri"
              ></v-text-field>
              <div v-if="selectedLanguage === 'Arabic'">
                <v-text-field
                  dir="rtl"
                  :label="selectedLanguage"
                  v-model.trim="language[selectedLanguage]"
                ></v-text-field>
              </div>
              <div v-else>
                <v-text-field
                  :label="selectedLanguage"
                  v-model.trim="language[selectedLanguage]"
                ></v-text-field>
              </div>
              <v-flex v-if="userLevel === 99">
                <img
                  v-if="language.image_uri"
                  :src="language.image_uri"
                  class="content_img"
                />
              </v-flex>
            </v-flex>
          </v-layout>
          <ResourceSelect
            v-if="isEditImage"
            resourceType="image"
            :isShow="isEditImage"
            :close="closeEditImage"
            :save="saveImage"
            :value="selectImageUri"
            :onSelect="onSelectImage"
          />
        </v-container>
      </v-card>
    </Modal>
    <!-- Add Modal -->
    <Modal
      v-if="isCreate"
      :isOpen="isCreate"
      :save="onSaveCreate"
      :close="onCloseCreate"
      :isLastStep="valid && validKeyStore && validateDuplicateKey.isChecking"
      title="Create"
    >
      <v-form ref="form" v-model="valid">
        <v-card>
          <v-container>
            <v-layout grid-list-xs column text-xs-center>
              <v-flex>
                <v-text-field
                  required
                  :disabled="disabled"
                  :rules="requiredRule"
                  :messages="validateDuplicateKey.answer"
                  label="Video URI"
                  v-model.trim="language.video_uri"
                ></v-text-field>
                <v-text-field
                  :rules="requiredRule"
                  :error-messages="errorMessages"
                  label="English SRT Link"
                  v-model.trim="language.English"
                ></v-text-field>
                <v-flex v-if="userLevel === 99">
                  <img
                    v-if="language.image_uri"
                    :src="language.image_uri"
                    class="content_img"
                  />
                </v-flex>
              </v-flex>
            </v-layout>
            <ResourceSelect
              v-if="isAddImage"
              resourceType="image"
              :isShow="isAddImage"
              :close="closeAddImage"
              :save="saveImage"
              :value="selectImageUri"
              :onSelect="onSelectImage"
            />
          </v-container>
        </v-card>
      </v-form>
    </Modal>
    <v-dialog
      v-model="dialog"
      fullscreen
      hide-overlay
      transition="fade-transition"
    >
      <v-card>
        <v-toolbar dark>
          <v-icon white @click="dialog = false">close</v-icon>
          | Press [esc] key to exit full screen
        </v-toolbar>
        <v-img :src="img" />
      </v-card>
    </v-dialog>
  </Container>
</template>
<script>
import { saveAs } from 'file-saver';
import { mapState, mapActions } from 'vuex';
import ResourceSelect from '../../components/ResourceSelect';
import Modal from '../../components/Modal';
import Container from '../../components/Container';
import { LANGUAGES } from '../../constants/localization/languageList';
import _ from 'lodash';
import Swal from 'sweetalert2';
export default {
  name: 'SubtitleVideoLocalization',
  components: {
    ResourceSelect,
    Container,
    Modal,
  },
  computed: {
    ...mapState({
      languageStore: state => state.subtitle_video_localization.language,
      updatedLanguageStore: state =>
        state.subtitle_video_localization.updateLanguage,
      updatedLanguagePrevStore: state =>
        state.subtitle_video_localization.updateLanguagePrev,
      languageJSONtoCSVStore: state =>
        state.subtitle_video_localization.languageJSONtoCSV,
      createdLanguageStore: state =>
        state.subtitle_video_localization.createLanguage,
      isSafeDeleteState: state =>
        state.subtitle_video_localization.isSafeDelete,
      userLevel: state => state.userInfo.userData.role_id,
      validKeyStore: state => state.subtitle_video_localization.isValidKey,
    }),
    form() {
      return {
        video_uri: this.language.video_uri,
      };
    },
  },
  data() {
    return {
      item: {},
      validateDuplicateKey: {
        answer: 'Please enter the video URI.',
        isChecking: null,
      },
      img: '',
      dialog: false,
      requiredRule: [v => !!v || 'Required, cannot be empty.'],
      errorMessages: '',
      valid: false,
      isAddImage: false,
      isEditImage: false,
      selectImageUri: '',
      disabled: false,
      language: {},
      search: '',
      isCreate: false,
      isEdit: false,
      editedIndex: -1,
      clearable: true,
      pagination: {
        rowsPerPage: 25,
      },
      selectedLanguage: '',
      languageList: LANGUAGES,
      header: [
        {
          text: 'Updated At',
          value: 'updated_at',
          align: 'center',
          sortable: true,
        },
        {
          text: 'Created At',
          value: 'created_at',
          align: 'center',
          sortable: true,
        },
        {
          text: 'Video URI',
          value: 'video_uri',
          align: 'center',
          sortable: true,
        },
        {
          text: 'Reference Language',
          value: 'English',
          align: 'center',
          sortable: false,
        },
        {
          text: 'Current Language',
          value: '',
          align: 'center',
          sortable: false,
        },
        { text: 'Action', value: 'action', align: 'center', sortable: false },
      ],
    };
  },
  methods: {
    ...mapActions('subtitle_video_localization', [
      'fetchLanguage',
      'uploadLanguageDataToS3',
      'addLanguage',
      'editLanguage',
      'deleteLanguage',
      'stateEditLanguage',
      'statePreviousData',
      'clearUpdateState',
      'clearUpdatePrevState',
      'publishToProduction',
      'checkDuplicateKey',
    ]),
    checkingKey() {
      this.validateDuplicateKey.answer = 'Checking key now...';
      this.validateDuplicateKey.isChecking = false;
      this.debouncedValidateKey();
      this.debouncedErrorMessage();
    },
    addSRT(video_uri) {
      this.language.video_uri = video_uri;
      this.disabled = true;
      this.isCreate = true;
      this.checkingKey();
    },
    validateKey() {
      let key = this.language.video_uri;
      this.checkDuplicateKey(key);
    },
    validateKeyFlag() {
      if (!this.validKeyStore) {
        this.validateDuplicateKey.answer =
          'Duplicate video_uri is detected, please re-enter the link.';
        if (this.disabled && this.isCreate) {
          this.$router.push({});
          Swal.fire({
            titleText: 'This video already has English SRT',
            text: `${this.language.video_uri}`,
            confirmButtonColor: 'primary',
            confirmButtonText: 'OK',
            showCancelButton: false,
            type: 'warning',
          }).then(result => {
            if (result.value) {
              this.onCloseCreate();
            }
          });
        }
      } else {
        this.validateDuplicateKey.answer = '';
        this.validateDuplicateKey.isChecking = true;
      }
    },
    fullscreenImage(image) {
      if (image) {
        this.dialog = true;
        this.img = image;
      }
    },
    saveFileLocally() {
      let blob = new Blob([this.languageJSONtoCSVStore], {
        type: 'text/csv',
      });
      const filename = `${this.selectedLanguage}.csv`;
      saveAs(blob, filename);
    },
    onClickAddLanguage() {
      this.language = {};
      this.isCreate = true;
      this.disabled = false;
      this.validateDuplicateKey.answer = 'Please enter the video URI.';
    },
    onSaveCreate() {
      this.addLanguage({
        languageData: this.language,
        selectedLanguage: this.selectedLanguage,
      });
      this.isCreate = false;
    },
    onCloseCreate() {
      this.isCreate = false;
      this.language = {};
    },
    async onClickEditLanguage(item) {
      this.item = item;
      this.statePreviousData({ key: '_id', value: item._id });
      if (item[this.selectedLanguage]) {
        this.statePreviousData({
          key: this.selectedLanguage,
          value: item[this.selectedLanguage],
        });
      } else {
        this.statePreviousData({
          key: this.selectedLanguage,
          value: '',
        });
      }
      this.language._id = item._id;
      this.isEdit = true;
      this.editedIndex = this.languageStore.indexOf(item);
      this.language = Object.assign({}, item);
    },
    async onSaveEdit() {
      const updateData = {
        from: this.updatedLanguagePrevStore,
        to: this.language,
      };
      await this.editLanguage({
        updateData: updateData,
        selectedLanguage: this.selectedLanguage,
      });
      this.onCloseEdit();
    },
    onCloseEdit() {
      this.clearUpdatePrevState();
      this.clearUpdateState();
      this.isEdit = false;
    },
    async onClickDeleteLanguage(id, English) {
      this.deleteLanguage({
        id: id,
        English: English,
        selectedLanguage: this.selectedLanguage,
      });
    },
    closeAddImage() {
      this.selectImageUri = '';
      this.isAddImage = !this.isAddImage;
    },
    closeEditImage() {
      this.selectImageUri = '';
      this.isEditImage = !this.isEditImage;
    },
    onSelectImage(uri) {
      this.selectImageUri = uri;
    },
    saveImage() {
      const uri = this.selectImageUri;
      if (this.isAddImage) {
        this.isAddImage = !this.isAddImage;
      } else if (this.isEditImage) {
        this.isEditImage = !this.isEditImage;
      }
      this.language.image_uri = uri;
      this.selectImageUri = '';
    },
  },
  created() {
    this.debouncedValidateKey = _.debounce(this.validateKey, 500);
    this.debouncedErrorMessage = _.debounce(this.validateKeyFlag, 900);
  },
  mounted() {
    if (this.$route.query.video_uri) {
      this.addSRT(this.$route.query.video_uri);
    }
    this.selectedLanguage = 'English';
    this.fetchLanguage(this.selectedLanguage);
  },
  watch: {
    selectedLanguage() {
      this.header[4].text = this.selectedLanguage;
      this.header[4].value = this.selectedLanguage;
      this.fetchLanguage(this.selectedLanguage);
    },
    'language.video_uri'(value) {
      if (value) {
        this.checkingKey();
      }
    },
  },
};
</script>

<style scoped>
.image_thumbnail {
  height: 50px;
  width: 50px;
  margin-top: 0px;
}
.modal-dialog {
  max-width: 100%;
  margin: 0;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  height: 100vh;
  display: flex;
}
</style>
